import { OrderRow } from "./types";

export const getOrderNumberDisplay = ({
  orderNumber,
  titleCompanyPrefix
}: {
  orderNumber: string;
  titleCompanyPrefix: string;
}) => {
  if (!orderNumber) return "";

  if(!titleCompanyPrefix) {
    return  orderNumber;
  }
  return `${titleCompanyPrefix.toUpperCase()}-${orderNumber}`;
};

export const orderNumberFilterFn = (row: { original: OrderRow }, _: string, filterValue: any) => {
  const { titleCompanyPrefix, orderNumber } = row.original;
  const orderNumberWithPrefix = titleCompanyPrefix ? `${titleCompanyPrefix}-${orderNumber}` : orderNumber;
  return orderNumberWithPrefix.toLowerCase().includes(filterValue.toLowerCase());
};
